import { getRecentSearches, recentSearchesLookup } from '../search_history';
import { normalizeStr } from '../autocomplete_helpers';

const DataConfig = (searchElement) => ({
  src: dataSrc(searchElement),
  key: ['suggestion'],
  cache: false,
});

const dataSrc = (searchElement) => async () => {
  const searchUrl = searchElement.dataset.searchurl;
  const maxResults = searchElement.dataset.maxresults;
  const { value: query } = searchElement;

  // Return trending results ONLY if the query is empty string
  if (query.length === 0) {
    const trendingSearchResults = JSON.parse(searchElement.dataset.trendingsearchresults);
    // Map trending structure to autocomplete structure
    // Limit both trending and recent searches to maxResults
    const trendingSearches = trendingSearchResults.map(({ result, score }) => ({
      suggestion: result,
      weight: score,
      type: 'trending',
    })).slice(0, maxResults);
    if (searchElement.dataset.searchHistory === 'true') {
      const recentSearchResults =  getRecentSearches().map((term, index) => ({
          suggestion: term,
          type: 'recent-search',
          weight: maxResults - index,
        }));

      return [...recentSearchResults, ...trendingSearches];
    }

    return trendingSearches;
  }

  const escapedQuery = encodeURIComponent(normalizeStr(query));
  const source = await fetch(`${searchUrl}?prefix=${escapedQuery}&limit=${maxResults}`, {
    headers: {
      'Accept': 'application/json',
    },
  });

  const data = await source.json();
  const recents = recentSearchesLookup(query) ?? [];
  const seen = new Set(recents.map(o => o.suggestion));
  const merged = [...recents];

  for (const obj of (data?.suggestions ?? [])) {
    if (!seen.has(obj.suggestion)) {
      merged.push(obj);
      seen.add(obj.suggestion);
    }
  }

  return merged;
};

export default DataConfig;
